import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { OrganizationsPage } from "../features/organizations/OrganizationsPage";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/organizations")({
  component: OrganizationsRoute,
});

function OrganizationsRoute() {
  const t = useT();
  const me = useMe();
  return (
    <>
      <h1>{t("organizations.title")}</h1>
      {me.data ? <OrganizationsPage me={me.data} /> : <p>{t("common.loading")}</p>}
    </>
  );
}
